window.$catalog_management_units_result = [];
window.$catalog_management_units_didUpdateChange = true;
window.$catalog_management_units_treeChangeStatus = false;
window.$catalog_management_units_treeList = [];
window.$catalog_management_units_page_number = 1;
window.$catalog_management_units_newInsertId = [];
window.$catalog_management_units_Glist = [];
window.$catalog_management_units_content = [];
window.$catalog_management_units_algemeenCode = [];
window.$catalog_management_units_algemeenNaam = [];
window.$catalog_management_units_selectedRow = [];
window.$catalog_management_units_gvv = 1;
window.$catalog_management_units_filterMaatregelenIsActive = [];
window.$catalog_management_units_filterPlannigIsActive = [];
window.$catalog_management_units_filterContent = [];
window.$catalog_management_units_filterClickStatus = false;
window.$catalog_management_units_scroll_change = false;
window.$catalog_management_units_columnList = [];
window.$catalog_management_units_selectedIds = null;
window.$catalog_management_units_token = null;
window.$catalog_management_units_table_total_row_count = 0;
window.$catalog_management_units_columnListPure = null;
window.$catalog_management_units_context = null;
window.$catalog_management_units_detail_context = null;
window.$catalog_management_units_sliderImages = [];
window.$catalog_management_units_refresh = function(){};
window.$catalog_management_units_lastUsedTableFilter = {
  content: [],
  definitions: [],
};

window.$catalog_management_units_actions = [
  {
    id: "787cf96e-0c70-4b20-8e4c-2ac70224b82c",
    text: "Beheereenheid toevoegen",
    class: "locate",
    modal: "beheereenheid_toevoegen",
  },
  {
    id: "708371ee-e3f6-4de7-87f8-dfe94b86f9b1",
    text: "Plaats in map",
    class: "locate",
    modal: "modal_koppel_aan_folder",
  },
];
window.$catalog_management_units_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "catalog>management-units",
        column_list: [
          "checkbox",
          "active",
          "Naam Beheereenheid",
          "Code beheereenheid",
          "paperclip",
          "Horizon",
        ],
      },
    ],
  },
};
